import React, { Component } from "react";

import Backend from "../utils/Backend";
import Notify from "../utils/Notify";

import StatsCard from "./components/stats-cards/StatsCard";
import ManageDriversTable from "./components/tables/manage-drivers/ManageDriversTable";

import DriverLastLocationMap from "./components/maps/DriverLastLocationMap";

import FetchHelper from "../utils/FetchHelper";

export default class ManageDrivers extends Component {
  constructor(props) {
    super(props);

    // this.state = {
    //   stats: null,
    // };



    this.state = {
      stats: null,
      drivers: [],
      driverMapLoading: false,
    };

  }

  // componentDidMount() {
  //   this._getStats();
  //   // this._getDriverCount();
  // }


//   componentDidMount() {
//   this._getStats();
//   this._getDriverLocations();
// }

// _parseDriverCoordinates(driver) {
//   const sources = [
//     driver?.last_known_location,
//     driver?.last_recorded_location,
//     driver?.previous_location,
//     driver?.current_location,
//     driver?.location,
//   ].filter(Boolean);

//   for (const source of sources) {
//     if (Array.isArray(source) && source.length >= 2) {
//       return {
//         latitude: Number(source[1]),
//         longitude: Number(source[0]),
//       };
//     }

//     if (typeof source === "object") {
//       const coordinates =
//         source?.coordinates ||
//         source?.geometry?.coordinates ||
//         source?.point?.coordinates;

//       if (Array.isArray(coordinates) && coordinates.length >= 2) {
//         return {
//           latitude: Number(coordinates[1]),
//           longitude: Number(coordinates[0]),
//         };
//       }

//       const latitude = source?.latitude ?? source?.lat;
//       const longitude = source?.longitude ?? source?.lng ?? source?.lon;

//       if (latitude != null && longitude != null) {
//         return {
//           latitude: Number(latitude),
//           longitude: Number(longitude),
//         };
//       }
//     }

//     if (typeof source === "string") {
//       const value = source.trim();

//       try {
//         if (value.startsWith("{") || value.startsWith("[")) {
//           const parsed = JSON.parse(value);
//           const parsedDriver = {
//             last_known_location: parsed,
//           };
//           const coordinates = this._parseDriverCoordinates(parsedDriver);

//           if (coordinates) {
//             return coordinates;
//           }
//         }
//       } catch (error) {
//         // Continue with text formats below.
//       }

//       const pointMatch = value.match(
//         /POINT\s*\(\s*(-?\d+(?:\.\d+)?)\s+(-?\d+(?:\.\d+)?)\s*\)/i
//       );

//       if (pointMatch) {
//         return {
//           longitude: Number(pointMatch[1]),
//           latitude: Number(pointMatch[2]),
//         };
//       }

//       const pairMatch = value.match(
//         /^\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*$/
//       );

//       if (pairMatch) {
//         return {
//           latitude: Number(pairMatch[1]),
//           longitude: Number(pairMatch[2]),
//         };
//       }
//     }
//   }

//   const latitude =
//     driver?.latitude ?? driver?.lat ?? driver?.address?.latitude;
//   const longitude =
//     driver?.longitude ??
//     driver?.lng ??
//     driver?.lon ??
//     driver?.address?.longitude;

//   return latitude != null && longitude != null
//     ? { latitude: Number(latitude), longitude: Number(longitude) }
//     : null;
// }

// async _getDriverLocations() {
//   this.setState({ driverMapLoading: true });

//   try {
//     const getPage = (page) => {
//       const query = new URLSearchParams();
//       query.append("application_status", "approved");
//       query.append("page", String(page));
//       query.append("page_size", "100");
//       query.append("pagination_type", "page");
//       query.append("ordering", "-created_at");

//       const separator = window.Api.Drivers.includes("?") ? "&" : "?";

//       return FetchHelper.get(
//         `${window.Api.Drivers}${separator}${query.toString()}`,
//         false
//       );
//     };

//     let response = await getPage(1);

//     let records = [...(response?.results || response || [])];
//     let hasNextPage = Boolean(response?.next);
//     let page = 2;
//     const totalCount = response?.count ?? response?.total ?? null;
//     const seenDriverIds = new Set(
//       records
//         .map((driver) => driver?.id)
//         .filter((driverId) => driverId != null)
//         .map(String)
//     );

//     /*
//      * The API currently caps each response at 20 drivers. Request subsequent
//      * page numbers against the exact same endpoint and approved-driver filter
//      * used by ManageDriversTable. Never fetch the absolute `next` URL because
//      * it can trigger a redirected CORS preflight.
//      */
//     while (
//       hasNextPage ||
//       (totalCount != null && records.length < totalCount)
//     ) {
//       const pageResponse = await getPage(page);
//       const pageRecords = pageResponse?.results || pageResponse || [];
//       let newDriverCount = 0;

//       pageRecords.forEach((driver) => {
//         const driverId = driver?.id;

//         if (driverId != null && !seenDriverIds.has(String(driverId))) {
//           seenDriverIds.add(String(driverId));
//           records.push(driver);
//           newDriverCount += 1;
//         }
//       });

//       if (!pageRecords.length || !newDriverCount) {
//         break;
//       }

//       hasNextPage = Boolean(pageResponse?.next);
//       page += 1;
//     }

//     const drivers = records.map((driver) => {
//       const coordinates = this._parseDriverCoordinates(driver) || {};
//       const location = driver?.last_known_location || {};
//       const fallbackLocation =
//         driver?.last_recorded_location ||
//         driver?.previous_location ||
//         driver?.current_location ||
//         driver?.location ||
//         {};
//       const address =
//         driver?.address ||
//         location?.address ||
//         fallbackLocation?.address ||
//         driver?.user?.address ||
//         {};
//       const user = driver?.user || {};
//       const isActive =
//         driver?.last_known_location != null &&
//         driver?.current_delivery_request == null;

//       return {
//         id: driver?.id,
//         name:
//           [user?.first_name, user?.last_name].filter(Boolean).join(" ") ||
//           driver?.name ||
//           user?.email ||
//           "Driver",
//         county:
//           driver?.county ||
//           location?.county ||
//           address?.county ||
//           address?.state,
//         latitude: coordinates.latitude,
//         longitude: coordinates.longitude,
//         isActive,
//         statusLabel: isActive ? "Able To Accept Deliveries" : "Offline",
//         lastLocationAt:
//           location?.updated_at ||
//           fallbackLocation?.updated_at ||
//           driver?.last_location_at ||
//           driver?.location_updated_at ||
//           driver?.last_seen,
//       };
//     });

//     this.setState({ drivers, driverMapLoading: false });
//   } catch (error) {
//     Notify.error(error.message || "Failed to load driver locations.");
//     this.setState({ driverMapLoading: false });
//   }
// }








componentDidMount() {
  this._getStats();
  this._getDriverLocations();
}

_parseDriverCoordinates(driver) {
  const sources = [
    driver?.last_known_location,
    driver?.last_recorded_location,
    driver?.previous_location,
    driver?.current_location,
    driver?.location,
  ].filter(Boolean);

  for (const source of sources) {
    if (Array.isArray(source) && source.length >= 2) {
      return {
        latitude: Number(source[1]),
        longitude: Number(source[0]),
      };
    }

    if (typeof source === "object") {
      const coordinates =
        source?.coordinates ||
        source?.geometry?.coordinates ||
        source?.point?.coordinates;

      if (Array.isArray(coordinates) && coordinates.length >= 2) {
        return {
          latitude: Number(coordinates[1]),
          longitude: Number(coordinates[0]),
        };
      }

      const latitude = source?.latitude ?? source?.lat;
      const longitude = source?.longitude ?? source?.lng ?? source?.lon;

      if (latitude != null && longitude != null) {
        return {
          latitude: Number(latitude),
          longitude: Number(longitude),
        };
      }
    }

    if (typeof source === "string") {
      const value = source.trim();

      try {
        if (value.startsWith("{") || value.startsWith("[")) {
          const parsed = JSON.parse(value);
          const parsedDriver = {
            last_known_location: parsed,
          };
          const coordinates = this._parseDriverCoordinates(parsedDriver);

          if (coordinates) {
            return coordinates;
          }
        }
      } catch (error) {
        // Continue with text formats below.
      }

      const pointMatch = value.match(
        /POINT\s*\(\s*(-?\d+(?:\.\d+)?)\s+(-?\d+(?:\.\d+)?)\s*\)/i
      );

      if (pointMatch) {
        return {
          longitude: Number(pointMatch[1]),
          latitude: Number(pointMatch[2]),
        };
      }

      const pairMatch = value.match(
        /^\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*$/
      );

      if (pairMatch) {
        return {
          latitude: Number(pairMatch[1]),
          longitude: Number(pairMatch[2]),
        };
      }
    }
  }

  const latitude =
    driver?.latitude ?? driver?.lat ?? driver?.address?.latitude;
  const longitude =
    driver?.longitude ??
    driver?.lng ??
    driver?.lon ??
    driver?.address?.longitude;

  return latitude != null && longitude != null
    ? { latitude: Number(latitude), longitude: Number(longitude) }
    : null;
}

async _getDriverLocations() {
  this.setState({ driverMapLoading: true });

  try {
    const getPage = (page) => {
      const query = new URLSearchParams();
      query.append("application_status", "approved");
      query.append("page", String(page));
      query.append("page_size", "100");
      query.append("pagination_type", "page");
      query.append("ordering", "-created_at");

      const separator = window.Api.Drivers.includes("?") ? "&" : "?";

      return FetchHelper.get(
        `${window.Api.Drivers}${separator}${query.toString()}`,
        false
      );
    };

    let response = await getPage(1);

    let records = [...(response?.results || response || [])];
    let hasNextPage = Boolean(response?.next);
    let page = 2;
    const totalCount = response?.count ?? response?.total ?? null;
    const seenDriverIds = new Set(
      records
        .map((driver) => driver?.id)
        .filter((driverId) => driverId != null)
        .map(String)
    );

    /*
     * The API currently caps each response at 20 drivers. Request subsequent
     * page numbers against the exact same endpoint and approved-driver filter
     * used by ManageDriversTable. Never fetch the absolute `next` URL because
     * it can trigger a redirected CORS preflight.
     */
    while (
      hasNextPage ||
      (totalCount != null && records.length < totalCount)
    ) {
      const pageResponse = await getPage(page);
      const pageRecords = pageResponse?.results || pageResponse || [];
      let newDriverCount = 0;

      pageRecords.forEach((driver) => {
        const driverId = driver?.id;

        if (driverId != null && !seenDriverIds.has(String(driverId))) {
          seenDriverIds.add(String(driverId));
          records.push(driver);
          newDriverCount += 1;
        }
      });

      if (!pageRecords.length || !newDriverCount) {
        break;
      }

      hasNextPage = Boolean(pageResponse?.next);
      page += 1;
    }

    const drivers = records.map((driver) => {
      const coordinates = this._parseDriverCoordinates(driver) || {};
      const location = driver?.last_known_location || {};
      const fallbackLocation =
        driver?.last_recorded_location ||
        driver?.previous_location ||
        driver?.current_location ||
        driver?.location ||
        {};
      const address =
        driver?.address ||
        location?.address ||
        fallbackLocation?.address ||
        driver?.user?.address ||
        {};
      const user = driver?.user || {};
      const isActive =
        driver?.last_known_location != null &&
        driver?.current_delivery_request == null;


           console.log("Driver API last seen:", {
        driverId: driver?.id,
        driverName: [user?.first_name, user?.last_name]
          .filter(Boolean)
          .join(" "),
        driverLastSeen: driver?.last_seen,
        userLastSeen: user?.last_seen,
        driverLastSeenAt: driver?.last_seen_at,
        lastLocationUpdatedAt: location?.updated_at,
        fallbackLocationUpdatedAt: fallbackLocation?.updated_at,
        user: user,
        driver: driver,
        last_login: user?.last_login,
      });

      return {
        id: driver?.id,
        name:
          [user?.first_name, user?.last_name].filter(Boolean).join(" ") ||
          driver?.name ||
          user?.email ||
          "Driver",
        county:
          driver?.county ||
          location?.county ||
          address?.county ||
          address?.state,
        latitude: coordinates.latitude,
        longitude: coordinates.longitude,
        isActive,
        statusLabel: isActive ? "Able To Accept Deliveries" : "Offline",
        lastSeenAt:
          driver?.last_seen ||
          user?.last_seen ||
          driver?.last_seen_at,
        lastLocationAt:
          location?.updated_at ||
          fallbackLocation?.updated_at ||
          driver?.last_location_at ||
          driver?.location_updated_at ||
          driver?.last_seen,
      };
    });

    this.setState({ drivers, driverMapLoading: false });
  } catch (error) {
    Notify.error(error.message || "Failed to load driver locations.");
    this.setState({ driverMapLoading: false });
  }
}















_getDriverCount() {
  Backend.getDrivers({
    // page_size: 1,
    // page: 1,
    // pagination_type: "page",
  })
    .then((res) => {
      console.log("Driver count response:", res);

      const driverCount =
        res?.count ??
        res?.total ??
        res?.total_count ??
        res?.results?.length ??
        0;

      this.setState((prevState) => ({
        stats: {
          ...prevState.stats,
          driver_count: driverCount,
        },
      }));
    })
    .catch((error) => {
      Notify.error(error.message);
    });
}

  // _getStats() {
  //   this.setState({ isLoading: true });

  //   Backend.getDriversStats()
  //     .then((stats) => {
  //       console.log("comming from _getStats(): ", stats);
  //       this.setState({ stats, isLoading: false });
  //     })
  //     .catch((error) => {
  //       Notify.error(error.message);
  //       this.setState({
  //         isLoading: false,
  //       });
  //     });
  // }




  _getStats() {
  this.setState({ isLoading: true });

  Backend.getDriversStats()
    .then((stats) => {
      console.log("comming from _getStats(): ", stats);

      this.setState((prevState) => ({
        stats: {
          ...prevState.stats,
          ...stats,
        },
        isLoading: false,
      }));
    })
    .catch((error) => {
      Notify.error(error.message);
      this.setState({
        isLoading: false,
      });
    });
}



  render() {
    const { stats } = this.state;

    console.log("Manage Driver this.state: ", this.state);
    // console.log("Manage Driver stats: ", stats.driver_count);

    if(!stats){
      return null
   }

    return (
      <div className="container">
        <div className="row wd-100 mb-5">
          <div className="col-lg-6 col-md-6 mb-4">
            {" "}
            <StatsCard
              data={[
                {
                  statsInfo: `${stats?.driver_count}`,
                  title: "Total Drivers",
                  icon: (
                    <g
                      stroke="none"
                      strokeWidth={1}
                      fill="none"
                      fillRule="evenodd"
                    >
                      <rect x={0} y={0} width={24} height={24} />
                      <path
                        d="M4.3618034,10.2763932 L4.8618034,9.2763932 C4.94649941,9.10700119 5.11963097,9 5.30901699,9 L15.190983,9 C15.4671254,9 15.690983,9.22385763 15.690983,9.5 C15.690983,9.57762255 15.6729105,9.65417908 15.6381966,9.7236068 L15.1381966,10.7236068 C15.0535006,10.8929988 14.880369,11 14.690983,11 L4.80901699,11 C4.53287462,11 4.30901699,10.7761424 4.30901699,10.5 C4.30901699,10.4223775 4.32708954,10.3458209 4.3618034,10.2763932 Z M14.6381966,13.7236068 L14.1381966,14.7236068 C14.0535006,14.8929988 13.880369,15 13.690983,15 L4.80901699,15 C4.53287462,15 4.30901699,14.7761424 4.30901699,14.5 C4.30901699,14.4223775 4.32708954,14.3458209 4.3618034,14.2763932 L4.8618034,13.2763932 C4.94649941,13.1070012 5.11963097,13 5.30901699,13 L14.190983,13 C14.4671254,13 14.690983,13.2238576 14.690983,13.5 C14.690983,13.5776225 14.6729105,13.6541791 14.6381966,13.7236068 Z"
                        fill="#FF5E8A"
                        opacity="0.3"
                      />
                      <path
                        d="M17.369,7.618 C16.976998,7.08599734 16.4660031,6.69750122 15.836,6.4525 C15.2059968,6.20749878 14.590003,6.085 13.988,6.085 C13.2179962,6.085 12.5180032,6.2249986 11.888,6.505 C11.2579969,6.7850014 10.7155023,7.16999755 10.2605,7.66 C9.80549773,8.15000245 9.45550123,8.72399671 9.2105,9.382 C8.96549878,10.0400033 8.843,10.7539961 8.843,11.524 C8.843,12.3360041 8.96199881,13.0779966 9.2,13.75 C9.43800119,14.4220034 9.7774978,14.9994976 10.2185,15.4825 C10.6595022,15.9655024 11.1879969,16.3399987 11.804,16.606 C12.4200031,16.8720013 13.1129962,17.005 13.883,17.005 C14.681004,17.005 15.3879969,16.8475016 16.004,16.5325 C16.6200031,16.2174984 17.1169981,15.8010026 17.495,15.283 L19.616,16.774 C18.9579967,17.6000041 18.1530048,18.2404977 17.201,18.6955 C16.2489952,19.1505023 15.1360064,19.378 13.862,19.378 C12.6999942,19.378 11.6325049,19.1855019 10.6595,18.8005 C9.68649514,18.4154981 8.8500035,17.8765035 8.15,17.1835 C7.4499965,16.4904965 6.90400196,15.6645048 6.512,14.7055 C6.11999804,13.7464952 5.924,12.6860058 5.924,11.524 C5.924,10.333994 6.13049794,9.25950479 6.5435,8.3005 C6.95650207,7.34149521 7.5234964,6.52600336 8.2445,5.854 C8.96550361,5.18199664 9.8159951,4.66400182 10.796,4.3 C11.7760049,3.93599818 12.8399943,3.754 13.988,3.754 C14.4640024,3.754 14.9609974,3.79949954 15.479,3.8905 C15.9970026,3.98150045 16.4939976,4.12149906 16.97,4.3105 C17.4460024,4.49950095 17.8939979,4.7339986 18.314,5.014 C18.7340021,5.2940014 19.0909985,5.62999804 19.385,6.022 L17.369,7.618 Z"
                        fill="#FF5E8A"
                      />
                    </g>
                  ),
                },
              ]}
            />{" "}
          </div>
          <div className="col-lg-6 col-md-6 mb-4">
            {" "}
            <StatsCard
              data={[
                {
                  statsInfo: `${stats?.delivered_order_count}`,
                  title: "Deliveries Made",
                  icon: (
                    <g
                      stroke="none"
                      strokeWidth={1}
                      fill="none"
                      fillRule="evenodd"
                    >
                      <rect x={0} y={0} width={24} height={24} />
                      <path
                        d="M22,17 L22,21 C22,22.1045695 21.1045695,23 20,23 L4,23 C2.8954305,23 2,22.1045695 2,21 L2,17 L6.27924078,17 L6.82339262,18.6324555 C7.09562072,19.4491398 7.8598984,20 8.72075922,20 L15.381966,20 C16.1395101,20 16.8320364,19.5719952 17.1708204,18.8944272 L18.118034,17 L22,17 Z"
                        fill="#FF5E8A"
                      />
                      <path
                        d="M2.5625,15 L5.92654389,9.01947752 C6.2807805,8.38972356 6.94714834,8 7.66969497,8 L16.330305,8 C17.0528517,8 17.7192195,8.38972356 18.0734561,9.01947752 L21.4375,15 L18.118034,15 C17.3604899,15 16.6679636,15.4280048 16.3291796,16.1055728 L15.381966,18 L8.72075922,18 L8.17660738,16.3675445 C7.90437928,15.5508602 7.1401016,15 6.27924078,15 L2.5625,15 Z"
                        fill="#FF5E8A"
                        opacity="0.3"
                      />
                      <path
                        d="M11.1288761,0.733697713 L11.1288761,2.69017121 L9.12120481,2.69017121 C8.84506244,2.69017121 8.62120481,2.91402884 8.62120481,3.19017121 L8.62120481,4.21346991 C8.62120481,4.48961229 8.84506244,4.71346991 9.12120481,4.71346991 L11.1288761,4.71346991 L11.1288761,6.66994341 C11.1288761,6.94608579 11.3527337,7.16994341 11.6288761,7.16994341 C11.7471877,7.16994341 11.8616664,7.12798964 11.951961,7.05154023 L15.4576222,4.08341738 C15.6683723,3.90498251 15.6945689,3.58948575 15.5161341,3.37873564 C15.4982803,3.35764848 15.4787093,3.33807751 15.4576222,3.32022374 L11.951961,0.352100892 C11.7412109,0.173666017 11.4257142,0.199862688 11.2472793,0.410612793 C11.1708299,0.500907473 11.1288761,0.615386087 11.1288761,0.733697713 Z"
                        fill="#FF5E8A"
                        fillRule="nonzero"
                        transform="translate(11.959697, 3.661508) rotate(-270.000000) translate(-11.959697, -3.661508) "
                      />
                    </g>
                  ),
                },
              ]}
            />{" "}
          </div>
        </div>


        <DriverLastLocationMap
          drivers={this.state.drivers}
          loading={this.state.driverMapLoading}
        />

        <ManageDriversTable />
      </div>
    );
  }
}
